export type Member = {
  id: number;
  company: string;
  name: string;
  description: string;
  image: string;
  alt: string;
};

export const MembersData: Member[] = [
  {
    id: 1,
    company: 'Company name',
    name: 'Karan',
    description: 'Greetings from the world of digital shipping! Has logistics ever been so simple?',
    image: 'member-01.png',
    alt: 'DFA Indian Member',
  },
  {
    id: 2,
    company: 'Company name',
    name: 'Aarush',
    description: 'Greetings from the world of digital shipping! Has logistics ever been so simple?',
    image: 'member-02.png',
    alt: 'Bhartiship Operating Tool',
  },
  {
    id: 3,
    company: 'Company name',
    name: 'Swathi',
    description: 'Greetings from the world of digital shipping! Has logistics ever been so simple?',
    image: 'member-03.png',
    alt: 'DFA Indian Member',
  },
  {
    id: 4,
    company: 'Company name',
    name: 'Ram',
    description: 'Greetings from the world of digital shipping! Has logistics ever been so simple?',
    image: 'member-04.png',
    alt: 'DFA Indian Member',
  },
];
